import { getUnauthenticatedLandingPath, WELCOME_LOGIN_PATH } from '@/core/constants/appConfig';
import { useAuth } from '@/core/contexts/AuthContext';
import { useIsAdhaJourney, useUIColors } from '@/core/hooks';
import { useRefreshAdhaCatalogueProfile } from '@/modules/auth/hooks/useRefreshAdhaCatalogueProfile';
import { useRefreshNormalCustomerProfile } from '@/modules/auth/hooks/useRefreshNormalCustomerProfile';
import { Redirect, Stack, usePathname, type Href } from 'expo-router';
import { Platform } from 'react-native';

/** Routes ADHA users must not open (owned properties / payments flows). */
const ADHA_BLOCKED_PATH_FRAGMENTS = [
  '/payments',
  '/payment-',
  '/property-payments',
  '/property-details',
  '/(home)/properties',
  '/(home)/payments',
] as const;

function isAdhaBlockedPath(pathname: string): boolean {
  return ADHA_BLOCKED_PATH_FRAGMENTS.some((fragment) =>
    pathname.includes(fragment),
  );
}

export default function AuthLayout() {
  useRefreshAdhaCatalogueProfile();
  useRefreshNormalCustomerProfile();
  const { isAuthenticated, isLoading } = useAuth();
  const colors = useUIColors();
  const isAdhaJourney = useIsAdhaJourney();
  const pathname = usePathname();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    // Web only: Universal landing when ENABLE_BLOOM_UNIVERSAL_LANDING. Native unchanged.
    const href =
      Platform.OS === 'web'
        ? getUnauthenticatedLandingPath()
        : WELCOME_LOGIN_PATH;
    return <Redirect href={href as Href} />;
  }

  if (
    Platform.OS === 'web' &&
    isAdhaJourney &&
    pathname &&
    isAdhaBlockedPath(pathname)
  ) {
    return <Redirect href="/(auth)/(home)" />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.backgroundLevel1 },
        statusBarStyle: 'dark',
      }}
    />
  );
}
